// client/src/components/common/Footer.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t, i18n } = useTranslation(['common', 'legal']);
  const currentYear = new Date().getFullYear();
  const currentLanguage = i18n.language || 'en';

  return (
    <footer className="bg-gray-800 text-white p-4 mt-auto">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-sm">
        <p>{t('common:footer.copyright', { year: currentYear })}</p>
        <div className="flex gap-4">
          <Link to="/pricing" className="text-gray-300 hover:text-white transition-colors">
            {currentLanguage === 'el' ? 'Τιμολόγηση' : 'Pricing'}
          </Link>
          <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">
            {t('legal:terms.title', 'Terms of Use')}
          </Link>
          <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">
            {t('legal:privacy.title', 'Privacy Policy')}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
